import styled from "styled-components";

// Shared layout for informational pages (privacy policy, terms, contact,
// list with us). Offsets the fixed header and keeps prose readable.
const StaticPageStyle = styled.section`
  padding: 110px 0 80px;
  font-family: var(--font-secondary);

  .container {
    max-width: 860px;
  }

  h1 {
    font-family: var(--font-primary);
    font-size: 32px;
    font-weight: 700;
    color: var(--color-dark);
    margin-bottom: 8px;
  }

  .page-meta {
    color: #6b7280;
    font-size: 14px;
    margin-bottom: 32px;
  }

  h2 {
    font-family: var(--font-primary);
    font-size: 22px;
    font-weight: 700;
    color: var(--color-dark);
    margin: 40px 0 12px;
  }

  h3 {
    font-family: var(--font-primary);
    font-size: 17px;
    font-weight: 700;
    color: var(--color-dark);
    margin: 24px 0 8px;
  }

  p,
  li {
    color: #374151;
    line-height: 1.7;
    margin-bottom: 12px;
  }

  ul {
    padding-left: 24px;
    margin-bottom: 16px;

    li {
      list-style: disc;
      margin-bottom: 8px;
    }
  }

  a {
    color: var(--color-accent, #3a7c8a);
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }

  .btn-primary {
    display: inline-block;
    background: var(--color-primary);
    color: #fff;
    padding: 14px 32px;
    border-radius: 100px;
    font-weight: 700;
    text-decoration: none;
    margin: 8px 0 24px;
  }

  .contact-cards {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    margin: 32px 0;

    @media screen and (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }
  }

  .contact-card {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;

    h2 {
      margin: 0 0 8px;
      font-size: 18px;
    }

    p {
      margin-bottom: 4px;
    }
  }

  .steps {
    counter-reset: step;
    padding-left: 0;
    margin: 24px 0;

    li {
      list-style: none;
      position: relative;
      padding-left: 56px;
      margin-bottom: 20px;
      counter-increment: step;

      &::before {
        content: counter(step);
        position: absolute;
        left: 0;
        top: 0;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: var(--color-primary);
        color: #fff;
        font-family: var(--font-primary);
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;

export default StaticPageStyle;
